import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";


export const reportPropertiesGridColumns: PolluxGridConfig[] = [
  {
    field: "checkbox",
    type: "checkbox",
    width: 40
  },
  {
    title: "report.valuationId",
    field: "PropertyId",
    width: 300,
  },
  {
    title: "report.propertyType",
    field: "PropertyTypeIDDescription",
    width: 300
  },
  {
    title: "report.propertyName",
    field: "PropertyName",
    width: 300
  },
  {
    title: "report.street",
    field: "PropertyStreet",
    width: 300
  },
  {
    title: "report.postalCode",
    field: "PropertyPostcode",
    width: 300
  },
  {
    title: "report.community",
    field: "PropertyMunicapelDescription",
    width: 300
  },
  {
    title: "report.federalState",
    field: "PropertyRegionDescription",
    width: 300
  },
  {
    title: "report.state",
    field: "PropertyCountryDescription",
    width: 300
  }
];
